import {required, email, sameAs} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core/dist/index.esm";
import {mixins} from "../app/mixin";

const fileSizeValidation = (value, vm) => {
    if (!value) {
        return true
    }
    const file = value
    return file.size < 2097153
}

const fileTypeValidation = (value, vm) => {
    if (!value) {
        return true
    }
    const fileName = value.name
    const pattern = /\.(pdf|docx|doc)$/
    return pattern.test(fileName)
}

mixins.push({
    el: '.applicationForm',
    delimiters: ['${', '}'],
    validations: {
        fullName: {required},
        city: {required},
        province: {required},
        phone: {required},
        email: {required, email},
        isKVKKApproved: {required, sameAs: sameAs(true)},
        coverLetter: {required},
        cvFile: {required, fileSizeValidation, fileTypeValidation},
        applicationType: {required},
    },
    data: () => ({
        v: useVuelidate(),
        API: window.api,
        jobId: window.jobId,
        isFormOpened: false,
        fullName: '',
        email: '',
        phone: '',
        city: 34,
        province: '',
        isKVKKApproved: false,
        cvFile: null,
        coverLetter: '',
        provinceList: [],
        applicationType: window.applicationType,
        status: '',
        lang: window.lang,
        siteKey: window.siteKey
    }),
    computed: {
        //todo locale
        errorMessage() {
            let errorMessage = ''
            if (!this.v.cvFile.fileSizeValidation) {
                errorMessage = "File size cannot exceed 2MB"
            }
            if (!this.v.cvFile.fileTypeValidation) {
                errorMessage = 'File type must be .pdf, .doc or .docx'
            }
            return errorMessage
        },
    },
    async mounted() {
        this.city = 34;
        await this.loadDistricts();
    },
    methods: {
        openForm() {
            this.isFormOpened = true
        },
        setCv(e) {
            this.$emit('input', e.target.files[0])
            this.cvFile = this.$refs.cv.files[0]
            this.v.cvFile.$touch()
        },
        async loadDistricts() {
            this.provinceList = [];

            const response = await fetch(`${this.API}/location/districts?city.id=${this.city}`, {
                method: "GET",
            });

            const json = await response.json();

            this.provinceList = json['hydra:member'];

            this.v.city.$touch();
        },
        async sendApplication() {
            this.v.$touch();

            if (!this.v.$invalid && this.isKVKKApproved) {
                try {
                    const recaptchaToken = await grecaptcha.execute(this.siteKey, { action: 'submit' });
                    const requestObject = {
                        fullName: this.fullName,
                        email: this.email,
                        phone: this.phone.toString(),
                        district: isNaN(this.province) ? this.province.id : this.province,
                        message: this.coverLetter,
                        job: this.jobId,
                        jobType: this.applicationType,
                        recaptchaToken: recaptchaToken
                    };

                    const response = await fetch(`${this.API}/job-applications`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.lang
                        },
                        body: JSON.stringify(requestObject)
                    });

                    if (response.status === 201) {
                        const data = await response.json();
                        await this.uploadCv(data.id);
                    } else {
                        console.error('Application error:', response);
                        throw new Error('application error');
                    }
                } catch (error) {
                    console.error('Error in sendApplication:', error);
                    this.status = 'ERROR';
                } finally {
                    setTimeout(() => {
                        this.status = '';
                    }, 15000);
                }
            }
        },
        async uploadCv(applicationId) {
            try {
                const recaptchaToken = await grecaptcha.execute(this.siteKey, { action: 'submit' });
                const requestData = new FormData();
                requestData.append('cvFile', this.cvFile, 'cvFile');
                requestData.append('recaptchaToken', recaptchaToken);

                const uploadResponse = await fetch(`${this.API}/job-applications/${applicationId}/upload-cv`, {
                    method: "POST",
                    body: requestData
                });

                if (uploadResponse.status === 201) {
                    this.resetForm();
                    this.status = 'SUCCESS';
                } else {
                    console.error('CV upload error:', uploadResponse);
                    throw new Error('CV upload error');
                }
            } catch (error) {
                console.error('Error in uploadCv:', error);
                this.status = 'ERROR';
            } finally {
                setTimeout(() => {
                    this.status = '';
                }, 15000);
            }
        },
        resetForm() {
            this.cvFile = '';
            this.fullName = '';
            this.email = '';
            this.phone = '';
            this.province = '';
            this.coverLetter = '';
            this.jobId = '';
            this.applicationType = '';
            this.isKVKKApproved = false;
            this.v.$reset();
        },
        goToForm() {
            const fullNameElem = document.getElementById('fullName')
            fullNameElem.focus()
        },
    },
});